import { useRef, useState } from 'react';
import Button from "react-bootstrap/Button";
import BackendForm from "../../components/forms/BackendForm";
import FloatingLabelField from "../../components/forms/FloatingLabelField";
import { concepts } from "fearless-common";
import { backendEndpoints } from "../../libs/backendEndpoints";
import CreateManyGroupsModals from "../../components/groups/CreateManyGroupsModals";
import FormFiller from "../../components/forms/FormFiller";
import Description from "../../components/Description";

const createFormId = 'create-form-id';

const answerSets = [
    {
        title: 'Alpha',
        answers: [{ name: 'name', value: `Group Alpha A` }],
    }, {
        title: 'Gamma',
        answers: [{ name: 'name', value: `Group Gamma G` }],
    },
];

/**
 * Form for creating a single group, with an additional option to batch-create
 * many groups at once via a modal.
 */
export default function GroupCreate({ onSuccess }: {
    /** Called with the response data after a group is successfully created. */
    onSuccess?: (resp: { data: { id: number }}) => void;
}) {
    const [showManyModal, setShowManyModal] = useState(false);
    // Keep a ref for reinitializing the form after each successful submission
    const ref = useRef(1);

    return (
        <>
            <BackendForm<{ name: string }, { id: number }>
                initialValues={{ name: '' }}
                key={ref.current}
                targetEndpoint={backendEndpoints.createGroup}
                targetMethod="POST"
                onSuccess={(resp) => {
                    // Reinitialize the form by incrementing the key
                    ref.current += 1;
                    if (onSuccess) onSuccess(resp);
                }}
                showFooter={false}
                formId={createFormId}
            >
                <h5>Create one new {concepts.Group.toLowerCase()}</h5>
                <div className="d-flex align-items-center mb-5">
                    <div className="flex-grow-1 me-3">
                        <FloatingLabelField name="name" label={`Your new ${concepts.Group.toLowerCase()} name`} autoFocus autoComplete />
                    </div>
                    <BackendForm.Footer showError={false} marginTop={false} buttonText="Create" />
                </div>
                <BackendForm.Feedback showError />
                <FormFiller answerSets={answerSets} formId={createFormId} />
            </BackendForm>
            <h5>Create many {concepts.Groups.toLowerCase()}</h5>
            <Description className="line-height-1-5">
                Create many {concepts.Groups.toLowerCase()} conveniently for your all student classes or research groups.
            </Description>
            <Button variant="primary" onClick={() => setShowManyModal(true)}>
                Start process
            </Button>
            {showManyModal && <CreateManyGroupsModals onClose={() => setShowManyModal(false)} />}
        </>
    );
}
